<template>
    <div class="vuetify-pagination">
        <div class="pagination-nav pagination-nav__prev" @click="previous">Back</div>
        <v-pagination
            v-model="value"
            ref="pagination"
            :length="length"
            :total-visible="6"
            @input="input"
        ></v-pagination>
        <div class="pagination-nav pagination-nav__next" @click="next">Forward</div>
    </div>
</template>

<script>
export default {
    name: 'vuetify-pagination',

    props: ['page', 'length'],

    data() {
        return {
            val: null
        }
    },

    computed: {
        value: {
            get() {
                if (this.val !== null) {
                    return this.val;
                }

                return this.page;
            },

            set(val) {
                this.val = val;
            }
        }
    },

    watch: {
        page(val) {
            this.val = val;
        }
    },

    methods: {
        input(val) {
            this.$emit('input', val)
        },

        previous() {
            if (this.value === 1) {
                return
            }
            this.$refs.pagination.previous({preventDefault: function(){}});
        },

        next() {
            if (this.value === this.length) {
                return
            }
            this.$refs.pagination.next({preventDefault: function(){}});
        }
    }
}
</script>

<style lang="scss" scoped>
    .vuetify-pagination {
        display: flex;
        align-items: center;

        ::v-deep .v-pagination__navigation {
            display: none;
        }

        ::v-deep {
            .theme--light.v-pagination {
                .v-pagination__item {
                    display: flex;
                    align-items: center;
                    height: 40px;
                    width: 40px;
                    margin: 0;
                    margin-left: -1px;
                    padding: 0;
                    justify-content: center;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    background: #FFFFFF;
                    border: 1px solid #D2D6E0;
                    box-sizing: border-box;
                    border-radius: 2px;
                    // // font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 15px;
                    line-height: 22px;
                    text-align: center;
                    letter-spacing: 0.005em;
                    color: #233346;
                    box-shadow: none;
                }

                .primary {
                    color: #233346;
                    background-color: #F4F5F7 !important;
                    border-color: #D2D6E0 !important;
                }
            }
        }
    }

    .pagination-nav {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        padding: 0 20px;
        background: #FFFFFF;
        border: 1px solid #D2D6E0;
        box-sizing: border-box;
        border-radius: 2px;
        // // font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 22px;
        text-align: center;
        letter-spacing: 0.005em;
        color: #233346;
        cursor: pointer;

        &__prev {
            margin-right: 15px;
        }

        &__next {
            margin-left: 15px;
        }
    }
</style>
